import { useFormContext } from 'react-hook-form';
import {
  hinhThucThanhToanSearchColumns,
  nguonDonSearchColumns,
  phuongThucThanhToanSearchColumns
} from '../cols-definition';
import type {
  KenhBanHangHinhThucThanhToan,
  KenhBanHangNguonDon,
  KenhBanHangPhuongThucThanhToan
} from '@/types/schemas';
import { FormField, SearchField } from '@/components/custom/erp';
import QUERY_KEYS from '@/constants/query-keys';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoProps {
  mode: FormMode;
  nguonDon: KenhBanHangNguonDon | null;
  hinhThucThanhToan: KenhBanHangHinhThucThanhToan | null;
  phuongThucThanhToan: KenhBanHangPhuongThucThanhToan | null;
  setNguonDon: (nguonDon: KenhBanHangNguonDon) => void;
  setHinhThucThanhToan: (hinhThucThanhToan: KenhBanHangHinhThucThanhToan) => void;
  setPhuongThucThanhToan: (phuongThucThanhToan: KenhBanHangPhuongThucThanhToan) => void;
}

function BasicInfo({
  mode,
  nguonDon,
  hinhThucThanhToan,
  phuongThucThanhToan,
  setNguonDon,
  setHinhThucThanhToan,
  setPhuongThucThanhToan
}: BasicInfoProps) {
  const isViewMode = mode === 'view';

  return (
    <div className='space-y-3 p-6'>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Mã kênh bán hàng</Label>
        <FormField type='text' name='ma_kbh' className='w-40' disabled={isViewMode || mode === 'edit'} />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Mã nguồn đơn</Label>
        <div>
          <SearchField<KenhBanHangNguonDon>
            type='text'
            displayRelatedField={'ten_nguondon'}
            columnDisplay={'ma_nguondon'}
            searchEndpoint={`/${QUERY_KEYS.DANH_MUC_NGUON_DON}/`}
            searchColumns={nguonDonSearchColumns}
            dialogTitle='Danh mục nguồn đơn'
            value={nguonDon?.ma_nguondon || ''}
            relatedFieldValue={nguonDon?.ten_nguondon || ''}
            onRowSelection={setNguonDon}
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Mã cửa hàng</Label>
        <FormField type='text' name='ma_cuahang' className='w-40' disabled={isViewMode} />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Hình thức thanh toán</Label>
        <div>
          <SearchField<KenhBanHangHinhThucThanhToan>
            type='text'
            displayRelatedField={'ten_httt'}
            columnDisplay={'ma_httt'}
            searchEndpoint={`/${QUERY_KEYS.HINH_THUC_THANH_TOAN}/`}
            searchColumns={hinhThucThanhToanSearchColumns}
            dialogTitle='Danh mục hình thức thanh toán'
            value={hinhThucThanhToan?.ma_httt || ''}
            relatedFieldValue={hinhThucThanhToan?.ten_httt || ''}
            onRowSelection={setHinhThucThanhToan}
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Phương thức thanh toán</Label>
        <div>
          <SearchField<KenhBanHangPhuongThucThanhToan>
            type='text'
            displayRelatedField={'ten_pttt'}
            columnDisplay={'ma_pttt'}
            searchEndpoint={`/${QUERY_KEYS.PHUONG_THUC_THANH_TOAN}/`}
            searchColumns={phuongThucThanhToanSearchColumns}
            dialogTitle='Danh mục phương thức thanh toán'
            value={phuongThucThanhToan?.ma_pttt || ''}
            relatedFieldValue={phuongThucThanhToan?.ten_pttt || ''}
            onRowSelection={setPhuongThucThanhToan}
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Tỉ lệ hoa hồng</Label>
        <FormField type='number' name='tl_hoahong' className='w-32' placeholder='0' disabled={isViewMode} />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Loại</Label>
        <FormField
          type='select'
          name='loai_kenh'
          className='w-44'
          options={[
            { label: '1. Online', value: 1 },
            { label: '2. Tại chỗ', value: 2 }
          ]}
          disabled={isViewMode}
        />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-48'>Trạng thái</Label>
        <FormField
          type='select'
          name='status'
          className='w-44'
          options={[
            { label: '1. Còn sử dụng', value: 1 },
            { label: '0. Không sử dụng', value: 0 }
          ]}
          disabled={isViewMode}
        />
      </div>
    </div>
  );
}

export default BasicInfo;
